import { LogoFidexaPrincipal } from "@/assets";
import { cn } from "@/utils";
import { ALPHA7_SITE_URL } from "../constants";

type PartnerLockupProps = {
  /** `sm` no cabeçalho; `lg` reservado para uso em destaque. */
  size?: "sm" | "lg";
  className?: string;
};

/**
 * As duas marcas lado a lado, separadas por um "+" discreto. A Alpha7 é PNG
 * (único formato disponível no site do parceiro); a Fidexa é o SVG principal.
 */
export const PartnerLockup = ({ size = "sm", className }: PartnerLockupProps) => {
  const fidexa = size === "lg" ? { width: 164, height: 40 } : { width: 123, height: 30 };
  const alpha7 = size === "lg" ? { width: 139, height: 44 } : { width: 104, height: 33 };

  return (
    <div className={cn("flex items-center gap-3 sm:gap-4", className)}>
      <span role="img" aria-label="Fidexa" className="inline-flex shrink-0">
        <LogoFidexaPrincipal width={fidexa.width} height={fidexa.height} />
      </span>
      <span
        aria-hidden="true"
        className={cn(
          "font-ds-display text-ds-ink-500 leading-none select-none",
          size === "lg" ? "text-ds-h2" : "text-ds-h4"
        )}
      >
        +
      </span>
      <a
        href={ALPHA7_SITE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Alpha7 Software (abre o site do parceiro em nova aba)"
        className="focus-visible:outline-ds-focus rounded-ds-sm inline-flex min-h-11 shrink-0 cursor-pointer items-center focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        <img
          src="/logos/alpha7.png"
          alt=""
          width={alpha7.width}
          height={alpha7.height}
          decoding="async"
        />
      </a>
    </div>
  );
};
